import moment from 'moment'
import parseDomain from "parse-domain"
import { get, isNumber } from 'lodash'
import cronstrue from 'cronstrue'
import currencyConfig from '../configs/currencies'
import { firebase } from '../firebase'

// Boilerplate borrowed from https://www.npmjs.com/package/web-push#using-vapid-key-for-applicationserverkey
export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[ i ] = rawData.charCodeAt(i)
  }
  return outputArray
}

export const currencyAmount = (currency, amount) => {
  const config = currencyConfig[ currency ] || {}

  return config.isZeroDecimal
    ? amount
    : amount * 100
}

export const extractSubDomainFromCurrent = () => {
  const { hostname } = window.location

  const parsed = parseDomain(hostname)

  return get(parsed, 'subdomain')
}

export const unixToReadableDate = (timestamp, format) => {
  // All timestamps are assumed to be UTC time
  return moment.unix(timestamp).format(format)
}

export const readableDateToUnix = (date) => {
  return moment(date).format('X')
}

export const unixDateDiff = (startUnix, endUnix, unitOfTime = 'days') => {
  const start = moment.unix(startUnix)
  const end = moment.unix(endUnix)

  return end.diff(start, unitOfTime)
}

export const readableCronSchedule = (schedule) => {
  const options = {
    locale: 'en'
  }

  let res = null
  try {
    res = cronstrue.toString(schedule, options)
  } catch (e) {
    res = false
  }

  return res
}

export const formatDate = (value) => {
  // @todo  localization & formatting
  return value && isNumber(value) && value > 0
    ? moment.unix(value).format('MMM D YYYY')
    : ''
}

export const formatMoney = ({ currency, amount = 0, hideZero = false, hideCurrency = false }) => {
  // Amount is expected to be in "cents"; No decimals!!!
  // @todo support other currencies
  const roundedAmount = Math.round(amount)
  const dollars = roundedAmount < 0
    ? (roundedAmount / 100) * -1
    : (roundedAmount / 100)

  const monies = currency
    ? dollars.toLocaleString('en-CA', { style: 'currency', currency })
    : dollars

  const currencyTxt = currency && !hideCurrency
    ? currency.toUpperCase()
    : ''

  if (hideZero && roundedAmount === 0) {
    return ''
  }

  const text = `${monies} ${currencyTxt}`.trim()

  return roundedAmount < 0
    ? `(${text})`
    : text
}

export const dayOfWeekParsed = (index) => {
  // for now; based off moment indexing Sun(0) - Sat(6)
  const dayOfWeek = moment().day(index).format('dddd')

  return {
    id: index,
    label: dayOfWeek
  }
}

export const weekOfYearParsed = (value) => {
  const val = value || ''
  const [ year, week ] = value.split('-')

  const startDay = moment().year(year).week(week).subtract(1, 'day').format('MMM D')
  const endDay = moment().year(year).week(week).endOf('week').format('MMM D')

  return {
    id: `${year}-${week}`, // id is what is saved
    label: `Week ${week} (${startDay} - ${endDay})`
  }
}

export const dateRangeParsed = (value) => {
  const val = value || ''
  const [ start, end ] = value.split('--')

  const startDay = moment(start).format('MMM D YYYY')
  const endDay = moment(end).format('MMM D YYYY')

  return {
    id: value, // id is what is saved, this should usually be the value given
    label: `${startDay} - ${endDay}`
  }
}

export const discountTotal = ({ coupon, currency, subtotal}) => {
  const { amount_off, percent_off } = coupon || {}

  if (amount_off) {
    const amount = (amount_off * -1)
    return formatMoney({ amount, currency, hideCurrency: true, hideZero: true })
  }
  if (percent_off) {
    const amount = (percent_off / 100) * subtotal * -1

    const ret = formatMoney({ amount, currency, hideCurrency: true, hideZero: true })
    return ret
  }
  return 0
}

export const convertTimestampToDate = (firebaseTimestamp) => {
  const { _seconds = 0, _nanoseconds = 0 } = firebaseTimestamp

  const { Timestamp } = firebase.firestore

  return new Timestamp(_seconds, _nanoseconds).toDate()
}

export const isErrorResponse = (response) => {
  const { status = 0 } = response || {}

  return (status >= 400 && status <= 499)
    || (status >= 500 && status <= 599)
}

export const generateUUID4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
